<!-- event-detail.component.html -->

@if (!isLoading && event) {
  <div class="min-h-screen bg-gray-50 dark:bg-slate-900 py-8 px-4">
    <div class="max-w-6xl mx-auto">
      <!-- Header avec navigation -->
      <div class="mb-8">
        <button
          (click)="goBack()"
          class="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white dark:text-white flex items-center gap-2 mb-4 transition"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Retour aux événements
        </button>
        <div
          class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
        >
          <div>
            <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              {{ event.name }}
            </h1>
            <div class="flex items-center gap-3">
              <span
                class="px-3 py-1 rounded-full text-sm font-medium"
                [ngClass]="{
                  'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300':
                    event.status === 'planned',
                  'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300':
                    event.status === 'completed' || event.status === 'analyzed',
                  'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300':
                    event.status === 'active',
                  'bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-gray-300':
                    event.status === 'cancelled',
                }"
              >
                {{
                  event.status === "planned"
                    ? "À venir"
                    : event.status === "active"
                      ? "En cours"
                      : event.status === "completed"
                        ? "À compléter"
                        : event.status === "analyzed"
                          ? "Analysé"
                          : "Annulé"
                }}
              </span>
            </div>
          </div>
          <!-- Actions menu -->
          <div class="flex gap-2">
            <button
              (click)="exportToPrint()"
              class="px-4 py-2 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition flex items-center gap-2"
              [class.opacity-50]="
                !planFeatureService.canAccess(FEATURES.EXPORT_PDF)
              "
              [class.cursor-not-allowed]="
                !planFeatureService.canAccess(FEATURES.EXPORT_PDF)
              "
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                />
              </svg>
              <span class="hidden sm:inline">Exporter</span>
              <app-plan-badge [feature]="FEATURES.EXPORT_PDF" />
            </button>
            @if (event.status === "planned") {
              <button
                (click)="editEvent()"
                class="px-4 py-2 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition flex items-center gap-2"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                <span class="hidden sm:inline">Modifier</span>
              </button>
            }
            <button
              (click)="duplicateEvent()"
              class="px-4 py-2 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition flex items-center gap-2"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
              <span class="hidden sm:inline">Dupliquer</span>
            </button>
            <button
              (click)="showDeleteConfirm = true"
              class="px-4 py-2 bg-white dark:bg-slate-800 border border-red-300 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-50 dark:bg-red-900/20 transition"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- Modal confirmation suppression -->
      @if (showDeleteConfirm) {
        <div
          class="fixed inset-0 bg-black bg-opacity-20 flex items-center justify-center z-[99999] p-4"
        >
          <div
            class="bg-white dark:bg-slate-800 rounded-2xl p-6 max-w-md w-full"
          >
            <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">
              Supprimer l'événement ?
            </h3>
            <p class="text-gray-600 dark:text-gray-400 mb-6">
              Cette action est irréversible. L'événement et toutes les données
              associées seront supprimés.
            </p>
            <div class="flex gap-3">
              <button
                (click)="showDeleteConfirm = false"
                class="flex-1 px-4 py-2 bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 dark:bg-slate-700 transition"
              >
                Annuler
              </button>
              <button
                (click)="deleteEvent()"
                class="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      }
      <!-- Contenu principal -->
      <div class="grid lg:grid-cols-3 gap-6">
        <!-- Colonne gauche : Infos événement -->
        <div class="lg:col-span-1 space-y-6">
          <!-- Card Informations -->
          <div
            class="bg-white dark:bg-slate-800 rounded-xl shadow-md dark:shadow-slate-900/50 p-6"
          >
            <h2 class="text-lg font-bold text-gray-900 dark:text-white mb-4">
              📋 Informations
            </h2>
            <div class="space-y-4">
              <div>
                <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                  📅 Date
                </div>
                <div class="font-medium text-gray-900 dark:text-white">
                  {{ formatDate(event.eventDate) }}
                </div>
              </div>
              <div>
                <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                  ⏰ Horaires
                </div>
                <div class="font-medium text-gray-900 dark:text-white">
                  {{ event.startTime }} - {{ event.endTime }}
                  <span class="text-gray-600 dark:text-gray-400 text-sm"
                    >({{ event.duration }} heures)</span
                  >
                </div>
              </div>
              <div>
                <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                  📍 Lieu
                </div>
                <div class="font-medium text-gray-900 dark:text-white">
                  {{ locationCity }}
                </div>
                @if (locationAddress) {
                  <div class="text-sm text-gray-500 dark:text-gray-400">
                    {{ locationAddress }}
                  </div>
                }
                @if (locationRouteData) {
                  <div
                    class="text-sm text-gray-500 dark:text-gray-400 mt-1 flex items-center gap-3"
                  >
                    <span
                      >📏 {{ locationRouteData.distanceKm }} km par la
                      route</span
                    >
                    <span
                      >🕐 {{ formatDuration(locationRouteData.durationMin) }} de
                      trajet</span
                    >
                  </div>
                }
              </div>
              <div>
                <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                  🎯 Type
                </div>
                <div class="flex items-center gap-2">
                  <span class="text-xl">{{
                    getEventTypeDetails(event.eventType)?.icon
                  }}</span>
                  <span class="font-medium text-gray-900 dark:text-white">{{
                    getEventTypeDetails(event.eventType)?.label
                  }}</span>
                </div>
              </div>
              @if (
                event.expectedAttendance &&
                event.expectedAttendance !== "unknown"
              ) {
                <div>
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    👥 Affluence
                  </div>
                  <div class="font-medium text-gray-900 dark:text-white">
                    {{
                      event.expectedAttendance === "low"
                        ? "Faible"
                        : event.expectedAttendance === "medium"
                          ? "Moyenne"
                          : "Forte"
                    }}
                  </div>
                </div>
              }
              <!-- Météo résumée dans les infos (prévisions live) -->
              @if (weatherAvailable && weatherForecast) {
                <div>
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    🌤️ Météo prévue
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="text-2xl">{{
                      getWeatherCodeIcon(weatherForecast.weatherCode)
                    }}</span>
                    <div>
                      <div class="font-medium text-gray-900 dark:text-white">
                        {{ weatherForecast.temperatureMin | number: "1.0-0" }}°
                        /
                        {{ weatherForecast.temperatureMax | number: "1.0-0" }}°C
                        <span
                          class="text-sm text-gray-500 dark:text-gray-400 capitalize"
                          >{{ weatherForecast.condition }}</span
                        >
                      </div>
                      <div class="flex items-center gap-2 mt-0.5">
                        <span
                          class="text-xs px-1.5 py-0.5 rounded-full font-medium"
                          [ngClass]="confidenceBgColor + ' ' + confidenceColor"
                        >
                          {{ confidenceLabel }} ({{ weatherConfidence }}%)
                        </span>
                        @if (weatherForecast.precipitationSum > 0) {
                          <span
                            class="text-xs text-blue-600 dark:text-blue-400"
                          >
                            💧
                            {{
                              weatherForecast.precipitationSum
                                | number: "1.0-1"
                            }}mm
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              } @else if (isLoadingWeather) {
                <div>
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    🌤️ Météo
                  </div>
                  <div class="text-sm text-gray-400 animate-pulse">
                    Chargement…
                  </div>
                </div>
              } @else if (weatherDaysAway > 16) {
                <div>
                  <div class="text-sm text-gray-600 dark:text-gray-400 mb-1">
                    🌤️ Météo
                  </div>
                  <div class="text-sm text-gray-400">Disponible J-16</div>
                </div>
              }
            </div>
          </div>
          <!-- Card Notes -->
          @if (event.notes) {
            <div
              class="bg-white dark:bg-slate-800 rounded-xl shadow-md dark:shadow-slate-900/50 p-6"
            >
              <h2 class="text-lg font-bold text-gray-900 dark:text-white mb-4">
                📝 Notes
              </h2>
              <p
                class="text-gray-700 dark:text-gray-300 text-sm whitespace-pre-wrap"
              >
                {{ event.notes }}
              </p>
            </div>
          }
        </div>
        <!-- Colonne droite : Recommandations -->
        <div class="lg:col-span-2">
          <!-- Carte de trajet (lecture seule) -->
          @if (event.location && $any(event.location).coordinates?.lat) {
            <div
              class="bg-white dark:bg-slate-800 rounded-xl shadow-md dark:shadow-slate-900/50 overflow-hidden mb-6"
            >
              <div
                class="px-5 py-3 border-b border-gray-100 dark:border-slate-700 flex items-center justify-between"
              >
                <span
                  class="font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2"
                >
                  🗺️ Trajet depuis votre base
                </span>
                @if (locationRouteData) {
                  <span
                    class="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-3"
                  >
                    <span>📏 {{ locationRouteData.distanceKm }} km</span>
                    <span
                      >🕐
                      {{ formatDuration(locationRouteData.durationMin) }}</span
                    >
                  </span>
                }
              </div>
              <div #routeMapContainer class="route-map-container"></div>
            </div>
          }

          <!-- Section Météo détaillée (sous la carte) -->
          @if (weatherAvailable && weatherForecast) {
            <div
              class="bg-white dark:bg-slate-800 rounded-xl shadow-md dark:shadow-slate-900/50 overflow-hidden mb-6"
            >
              <div
                class="px-5 py-4 border-b border-gray-100 dark:border-slate-700"
              >
                <div class="flex items-center justify-between">
                  <h3
                    class="font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2"
                  >
                    🌡️ Prévisions météo détaillées
                  </h3>
                  <span
                    class="text-xs px-2 py-1 rounded-full font-medium"
                    [ngClass]="confidenceBgColor + ' ' + confidenceColor"
                  >
                    Confiance {{ weatherConfidence }}%
                  </span>
                </div>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Prévisions pour {{ formatDate(event.eventDate) }}
                  @if (event.startTime && event.endTime) {
                    — {{ event.startTime }} à {{ event.endTime }}
                  }
                </p>
              </div>

              <div class="p-5">
                <!-- Résumé conditions du jour -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
                  <div
                    class="text-center p-3 rounded-lg bg-gray-50 dark:bg-slate-900"
                  >
                    <div class="text-2xl mb-1">
                      {{ getWeatherCodeIcon(weatherForecast.weatherCode) }}
                    </div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">
                      Condition
                    </div>
                    <div
                      class="font-semibold text-gray-900 dark:text-white text-sm capitalize"
                    >
                      {{ weatherForecast.condition }}
                    </div>
                  </div>
                  <div
                    class="text-center p-3 rounded-lg bg-gray-50 dark:bg-slate-900"
                  >
                    <div class="text-2xl mb-1">🌡️</div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">
                      Températures
                    </div>
                    <div
                      class="font-semibold text-gray-900 dark:text-white text-sm"
                    >
                      {{ weatherForecast.temperatureMin | number: "1.0-0" }}° /
                      {{ weatherForecast.temperatureMax | number: "1.0-0" }}°C
                    </div>
                  </div>
                  <div
                    class="text-center p-3 rounded-lg bg-gray-50 dark:bg-slate-900"
                  >
                    <div class="text-2xl mb-1">💧</div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">
                      Précipitations
                    </div>
                    <div
                      class="font-semibold text-gray-900 dark:text-white text-sm"
                    >
                      {{ weatherForecast.precipitationSum | number: "1.0-1" }}mm
                    </div>
                  </div>
                  <div
                    class="text-center p-3 rounded-lg"
                    [ngClass]="
                      weatherImpactPct === 0
                        ? 'bg-green-50 dark:bg-green-900/20'
                        : 'bg-red-50 dark:bg-red-900/20'
                    "
                  >
                    <div class="text-2xl mb-1">
                      {{ weatherImpactPct === 0 ? "✅" : "⚠️" }}
                    </div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">
                      Impact reco
                    </div>
                    <div
                      class="font-semibold text-sm"
                      [ngClass]="
                        weatherImpactPct === 0
                          ? 'text-green-600 dark:text-green-400'
                          : 'text-red-600 dark:text-red-400'
                      "
                    >
                      {{
                        weatherImpactPct === 0
                          ? "Aucun"
                          : weatherImpactPct + "%"
                      }}
                    </div>
                  </div>
                </div>

                <!-- Créneaux horaires (si disponibles) -->
                @if (weatherSlots.length > 0) {
                  <div class="mb-4">
                    <h4
                      class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2"
                    >
                      ⏰ Détail horaire pendant l'événement
                      <span class="text-xs text-gray-400 font-normal"
                        >({{ event.startTime }} – {{ event.endTime }})</span
                      >
                    </h4>
                    <div
                      class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2"
                    >
                      @for (slot of weatherSlots; track slot.hour) {
                        <div
                          class="rounded-lg p-2.5 text-center border border-gray-100 dark:border-slate-700 transition"
                          [ngClass]="getSlotBgClass(slot)"
                        >
                          <div
                            class="text-xs font-semibold text-gray-700 dark:text-gray-300"
                          >
                            {{ slot.hour }}
                          </div>
                          <div class="text-lg my-1">
                            {{ getWeatherCodeIcon(slot.weatherCode) }}
                          </div>
                          <div
                            class="text-sm font-bold text-gray-900 dark:text-white"
                          >
                            {{ slot.temperature }}°
                          </div>
                          @if (slot.precipitationProbability > 0) {
                            <div
                              class="text-xs mt-0.5"
                              [ngClass]="
                                slot.precipitationProbability > 50
                                  ? 'text-blue-600 dark:text-blue-400 font-semibold'
                                  : 'text-gray-400'
                              "
                            >
                              💧 {{ slot.precipitationProbability }}%
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                } @else if (weatherDaysAway > 1) {
                  <div
                    class="text-center py-4 text-sm text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-slate-900 rounded-lg"
                  >
                    ⏰ Le détail horaire sera disponible le jour de l'événement
                  </div>
                }

                <!-- Impact sur recommandations -->
                <div
                  class="mt-4 p-4 rounded-lg border"
                  [ngClass]="
                    weatherImpactPct === 0
                      ? 'border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/10'
                      : 'border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/10'
                  "
                >
                  <div class="flex items-start gap-3">
                    <span class="text-xl">{{
                      weatherImpactPct === 0 ? "🟢" : "🟠"
                    }}</span>
                    <div>
                      <div
                        class="text-sm font-semibold text-gray-800 dark:text-gray-200"
                      >
                        Impact sur les recommandations
                      </div>
                      <p class="text-xs text-gray-600 dark:text-gray-400 mt-1">
                        {{ weatherImpactText }}
                      </p>
                      @if (weatherImpactPct !== 0) {
                        <p
                          class="text-xs text-gray-500 dark:text-gray-400 mt-2"
                        >
                          💡 Les quantités recommandées ci-dessous intègrent
                          déjà cet ajustement météo.
                        </p>
                      }
                    </div>
                  </div>
                </div>

                <!-- Indice de confiance détaillé -->
                <div class="mt-4 flex items-center gap-3">
                  <div class="flex-1">
                    <div
                      class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mb-1"
                    >
                      <span>Indice de confiance</span>
                      <span class="font-medium" [ngClass]="confidenceColor"
                        >{{ weatherConfidence }}%</span
                      >
                    </div>
                    <div
                      class="w-full bg-gray-200 dark:bg-slate-700 rounded-full h-2"
                    >
                      <div
                        class="h-2 rounded-full transition-all duration-500"
                        [style.width.%]="weatherConfidence"
                        [ngClass]="{
                          'bg-green-500': weatherConfidence >= 88,
                          'bg-blue-500':
                            weatherConfidence >= 75 && weatherConfidence < 88,
                          'bg-amber-500':
                            weatherConfidence >= 60 && weatherConfidence < 75,
                          'bg-gray-400': weatherConfidence < 60,
                        }"
                      ></div>
                    </div>
                    <div
                      class="text-[10px] text-gray-400 dark:text-gray-500 mt-1"
                    >
                      Prévision à J-{{ weatherDaysAway }} —
                      {{ confidenceLabel | lowercase }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Header recommandations (accordion) -->
          <button
            type="button"
            class="w-full text-left bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl shadow-lg dark:shadow-slate-900/50 p-6 text-white mb-6 flex items-center justify-between"
            (click)="toggleRecommandations()"
            [attr.aria-expanded]="recommandationsOpen"
          >
            <div>
              <h2 class="text-2xl font-bold mb-2">
                📊 Recommandations de préparation
              </h2>
              <p class="text-purple-100">
                Quantités optimales calculées pour ton événement
              </p>
            </div>
            <div class="ml-4">
              <svg
                class="w-6 h-6 transform transition-transform"
                [ngClass]="{ 'rotate-180': recommandationsOpen }"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </button>
          <!-- Tableau recommandations (collapsible) -->
          @if (recommandationsOpen) {
            <div
              class="bg-white dark:bg-slate-800 rounded-xl shadow-md dark:shadow-slate-900/50 overflow-hidden"
            >
              <div class="overflow-x-auto">
                <table class="w-full">
                  <thead class="bg-gray-50 dark:bg-slate-900 border-b">
                    <tr>
                      <th
                        class="px-6 py-4 text-left text-sm font-semibold text-gray-900 dark:text-white"
                      >
                        Produit
                      </th>
                      <th
                        class="px-6 py-4 text-center text-sm font-semibold text-gray-900 dark:text-white"
                      >
                        Recommandé
                      </th>
                      <th
                        class="px-6 py-4 text-center text-sm font-semibold text-gray-900 dark:text-white"
                      >
                        Fourchette
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 dark:divide-slate-700">
                    @for (reco of recommandations; track reco) {
                      <tr
                        class="hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition"
                      >
                        <td class="px-6 py-4">
                          <div
                            class="font-medium text-gray-900 dark:text-white"
                          >
                            {{ reco.productName }}
                          </div>
                          <div class="text-sm text-gray-600 dark:text-gray-400">
                            {{ reco.unit }}
                          </div>
                        </td>
                        <td class="px-6 py-4 text-center">
                          <div
                            class="text-2xl font-bold bg-gradient-to-r from-purple-600 to-purple-700 bg-clip-text text-transparent"
                          >
                            {{ reco.recommended }}
                          </div>
                        </td>
                        <td class="px-6 py-4 text-center">
                          <div class="text-sm text-gray-600 dark:text-gray-400">
                            {{ reco.rangeLow }} - {{ reco.rangeHigh }}
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          <!-- Section 'Pourquoi ces quantités ?' removed -->
          <!-- CTA Saisie ventes (si événement passé) -->
          @if (isEventPast()) {
            <div class="mt-6">
              <div
                class="bg-green-50 dark:bg-green-900/20 border-2 border-green-200 dark:border-green-800 rounded-xl p-6"
              >
                <div class="flex items-start gap-4">
                  <div class="flex-shrink-0">
                    <div
                      class="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center"
                    >
                      <svg
                        class="w-6 h-6 text-green-600 dark:text-green-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="flex-1">
                    <h3 class="text-lg font-bold text-green-900 mb-2">
                      📝 Événement terminé !
                    </h3>
                    <p class="text-green-800 dark:text-green-300 mb-4">
                      Saisis tes ventes pour améliorer les prochaines
                      recommandations et voir ta précision.
                    </p>
                    <button
                      (click)="goToSalesInput()"
                      class="px-6 py-3 bg-green-600 text-white rounded-lg font-bold hover:bg-green-700 transition"
                    >
                      Saisir mes ventes →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Actions rapides -->
          <div class="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <button
              (click)="exportToPrint()"
              class="px-6 py-4 bg-white dark:bg-slate-800 border-2 border-purple-600 text-purple-600 rounded-xl font-bold hover:bg-purple-50 dark:bg-purple-900/20 transition flex items-center justify-center gap-2"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                />
              </svg>
              📄 Exporter ma liste
            </button>
            <button
              (click)="duplicateEvent()"
              class="px-6 py-4 bg-white dark:bg-slate-800 border-2 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 rounded-xl font-bold hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition flex items-center justify-center gap-2"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
              📋 Dupliquer l'événement
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Loading state -->
@if (isLoading) {
  <div
    class="min-h-screen bg-gray-50 dark:bg-slate-900 flex items-center justify-center"
  >
    <div class="text-center">
      <svg
        class="animate-spin h-12 w-12 text-purple-600 mx-auto mb-4"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <p class="text-gray-600 dark:text-gray-400">
        Chargement des recommandations...
      </p>
    </div>
  </div>
}

<!-- Error state -->
@if (!isLoading && errorMessage) {
  <div
    class="min-h-screen bg-gray-50 dark:bg-slate-900 flex items-center justify-center p-4"
  >
    <div
      class="bg-white dark:bg-slate-800 rounded-2xl shadow-lg dark:shadow-slate-900/50 p-8 max-w-md text-center"
    >
      <div class="text-6xl mb-4">😕</div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Oups !
      </h2>
      <p class="text-gray-600 dark:text-gray-400 mb-6">{{ errorMessage }}</p>
      <button
        (click)="goBack()"
        class="px-6 py-3 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition"
      >
        Retour aux événements
      </button>
    </div>
  </div>
}

<!-- Print styles -->
<style media="print">
  @media print {
    body * {
      visibility: hidden;
    }
    .print-area,
    .print-area * {
      visibility: visible;
    }
    .print-area {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
    button,
    .no-print {
      display: none !important;
    }
  }
</style>
